// 意大利
export default {
  Login: {
    Title: "Accedi al tuo account",
    describe: "Accedi o crea un account per iniziare.",
    Google: "Continua con Google",
    Apple: "Continua con Apple",
    or: "O",
    Emailplaceholder: "Indirizzo email",
    Passwordplaceholder: "Password",
    Login: "Accedi",
    forgot: "Hai dimenticato la password?",
    notAccount: "Non hai un account Fineshare?",
    Signup: "Registrati",
    InvalidEmail: "Formato email non valido.",
    InvalidPassword: "La password deve contenere almeno 6 caratteri.",
    loading: "Caricamento...",
    login: "Accedi",
    errorText: "Accesso fallito, verifica il tuo nome utente e la tua password",
  },
  signup: {
    Title: "Crea il tuo account",
    describe: "Crea il tuo account Fineshare in pochi secondi.",
    Google: "Registrati con Google",
    Apple: "Registrati con Apple",
    or: "O",
    Emailplaceholder: "Inserisci l'indirizzo email",
    Passwordplaceholder: "Inserisci una password di 6 cifre",
    Already: "Hai già un account?",
    Login: "Accedi",
    By: "Creando un account, accetto di aver letto e accettato la",
    Privacy: "Politica sulla privacy",
    Terms: "Termini di utilizzo.",
    and: "e",
    signupText: "Crea il tuo account",
    InvalidEmail: "Formato email non valido.",
    InvalidPassword: "La password deve contenere almeno 6 caratteri.",
    loading: "Caricamento...",
    passwordError: "L'indirizzo email è già stato registrato",
    again: "Stai facendo troppe richieste, riprova più tardi",
    Registration: "Registrazione fallita, verifica la tua email e password.",
    hasRegistered: "L'indirizzo email è già stato registrato",
    Title2: "Crea il tuo account Fineshare",
  },
  Home: {
    Welcome: "Benvenuto nel Centro Account Fineshare",
    Hi: "Ciao,",
    Order: "I Miei Ordini",
    orders: "Visualizza i nostri ordini di acquisto",
    Learn: "Scopri di più",
    Product: "Gestisci Prodotti",
    products: "Visualizza i miei prodotti acquistati",
    Setting: "Impostazioni dell'Account",
    Settings: "Dettagli dell'account e cambia la tua password",
    account: "Sfrutta al massimo il tuo account",
    FineCam: "FineCam",
    FineCams: "Crea e condividi i tuoi video ispiratori ovunque",
    FineVoice: "FineVoice",
    FineVoices: "Crea doppiaggi con le tue voci preferite, come vuoi tu",
    VoiceTrans: "VoiceTrans",
    VoiceTranss: "Trasforma la tua voce, trasmetti le tue emozioni",
    Singify: "Singify",
    Singifys: "Crea cover AI con le voci che desideri",
  },
  success: {
    Congratulations: "Congratulazioni!",
    successfully: "Il tuo account Fineshare è stato creato con successo.",
  },
  successapp: {
    Successful: "Accesso riuscito!",
    successfully1:
      "Ti sei connesso con successo al tuo account Fineshare e ora puoi iniziare a utilizzare l'app.",
    successfully2:
      "Ti sei connesso con successo al tuo account Fineshare. Ora puoi chiudere questa finestra e iniziare a utilizzare l'app.",
    Go: "Vai al Centro Utenti Fineshare",
  },
  forgot: {
    ForgotPas: "Hai dimenticato la password?",
    Enter1: "Inserisci l'email per reimpostare la password",
    Enter2:
      "Inserisci il tuo indirizzo email e ti invieremo un link per reimpostare la password.",
    exmple: "nome@esempio.com",
    Back: "Torna al login",
    submitText: "Invia",
    errorText: "Per favore inserisci il tuo indirizzo email",
    loading: "caricamento...",
    sent: "Abbiamo inviato un'email al tuo indirizzo",
    notExist: "La tua email non esiste, per favore conferma la tua email",
    Reset: "Ripristino fallito, per favore conferma la tua email",
  },
  account: {
    Settings: "Impostazioni dell'Account",
    Change: "Modifica i dettagli del tuo account, password e altro.",
    Personal: "Informazioni Personali",
    email: "E-mail:",
    Name: "Nome utente:",
    Edit: "Modifica",
    title: "Cambia nome utente",
    message: "Il nome inserito non può essere vuoto.",
    placeholder: "Inserisci il tuo nome utente",
    Reset: "Resetta la password",
    Resets:
      "Puoi resettare la tua password, inserisci 6 o più numeri e la password",
    ResetPas: "Resetta la password",
    Delete: "Elimina Account",
    Deletes:
      "Questo eliminerà permanentemente il tuo account e tutti i suoi dati, e non potrai riattivarlo.",
    sure: "Sei sicuro di voler eliminare il tuo account Fineshare?",
    sures:
      "Una volta che il tuo account sarà eliminato, tutti i tuoi dati su Fineshare verranno rimossi permanentemente. Per procedere con l'eliminazione dell'account, ti abbiamo inviato un codice di verifica. Inserisci il codice e clicca su Conferma.",
    Deletebtn: "Elimina",
    Deleteplaceholder: "Inserisci il codice di verifica a 6 cifre",
  },
  order: {
    Order: "I miei ordini",
    history:
      "La tua cronologia degli ordini è stata registrata su questa pagina",
    dont: "Non hai ancora prodotti",
    Buy: "Acquista ora per ottenere più ottimizzazione, clicca sul pulsante sottostante per ottenerlo ora",
    BuyBtn: "Acquista Ora",
    OrderId: "ID dell'Ordine:",
    Price: "Prezzo:",
    Date: "Data dell'Ordine:",
  },
  Product: {
    Product: "Il mio prodotto",
    products: "I prodotti registrati nel tuo account",
    dont: "Non hai ancora prodotti",
    Management: "Gestisci dispositivi >",
  },
  redeem: {
    Redeem: "Riscatta Abbonamento",
    products: "Qui puoi riscattare i prodotti Fineshare",
    Please: "Per favore inserisci il tuo codice di riscatto",
    placeholder: "Codice di riscatto",
    Submit: "Invia",
    Notes: "Note:",
    Notes1: "1.Formato del codice di riscatto: XXXXX;",
    Notes2:
      "2.Per visualizzare i tuoi prodotti riscattati, fai clic sul menu 'Prodotto'.",
    Successfully: "Riscatto riuscito",
    Follow: "Segui i passaggi qui sotto per iniziare a usare VoiceTrans:",
    step1: "1. Scarica e installa Fineshare VoiceTrans.",
    step2: "2. Apri VoiceTrans e vai su ",
    Account: "Account",
    step3:
      "3. Inserisci la tua email e la tua password per accedere al tuo account Fineshare.",
    Tips: "Suggerimenti: Per un miglior utilizzo, leggi la ",
    guide: "guida",
    Redemption: "Riscatto fallito",
    redeemed:
      "Il codice di riscatto è stato già utilizzato. Apri il software e accedi nuovamente al tuo account per iniziare ad usarlo.",
    Failed: "Riscatto fallito",
    check: "Per favore verifica il tuo codice di riscatto.",
  },
  details: {
    Product: "Il mio prodotto",
    products: "Tutti i prodotti che hai acquistato sono su questa pagina",
    Back: "Indietro alla lista",
    Name: "Nome dispositivo",
    system: "Sistema dispositivo",
    status: "Stato dispositivo",
    Operation: "Operazione",
    Delete: "Elimina",
    contact:
      "Al momento non è supportata la rimozione diretta del dispositivo. Se hai bisogno di rimuovere il dispositivo, contattaci a ",
  },
  nav: {
    Home: "Home",
    Account: "Account",
    Order: "Ordine",
    Product: "Prodotto",
    Redeem: "Riscattare",
    Help: "Centro di Aiuto",
  },
  auth: {
    Authorization: "Autorizzazione riuscita!",
    wait: "Tornando all'applicazione, attendere prego...",
  },
  notfound: {
    Not: "Pagina non trovata",
    Unfortunately:
      "Purtroppo la pagina che stai cercando non esiste o c'è un errore nel link che hai inserito.",
    Home: "Vai alla home page",
  },
  topuser: {
    Settings: "Impostazioni Account",
    language: "Lingua",
    Logout: "Esci",
  },
  loginweb: {
    Conversion: "La conversione sta per iniziare",
    currently: "Attualmente ci sono ",
    people: " persone in coda!",
    Please:
      "Accedi e ti invieremo i risultati al tuo indirizzo email una volta completata la conversione.",
    dont: "Non voglio accedere",
  },
  mobilelogin: {
    Welcome: "Benvenuto su Fineshare! Accedi per iniziare.",
  },
  reset: {
    Reset: "Reimposta una nuova password",
    Password:
      "La password deve contenere almeno 6 caratteri, con almeno 1 lettera e 1 numero.",
    password: "Inserisci la tua nuova password",
    Back: "Torna al login",
    Congratulations: "Congratulazioni!",
    successfully:
      "Password reimpostata con successo, inizia subito ad accedere",
    Login: "Accedi",
    Please: "Inserisci 6 cifre e lettere",
    failed:
      "Reimpostazione della password fallita, clicca sul link di reimpostazione nella tua casella di posta",
  },
  verification: {
    verification: "Inserisci il codice di verifica",
    haveverification: "Abbiamo inviato un codice di verifica a ",
    Please: ". Inserisci il codice di verifica che hai ricevuto qui sotto:",
    Enter: "Inserisci il codice di verifica a 6 cifre",
    Resend: "Rinvio codice di verifica",
    Wait: "Attendi ",
    again: " secondi e invia di nuovo",
    Verify: "Verifica",
    error: "Errore nel codice di verifica",
    verificationcode: "Inserisci il codice di verifica",
  },
};
